import { useSearchParams, useNavigate } from 'react-router-dom'
import { Check } from 'lucide-react'

const CreditWithdrawSuccess = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const orderCode = searchParams.get('code')

  const handleOkClick = () => {
    navigate('/')
  }

  return (
    <div className="flex w-full flex-col items-center justify-center">
      <div className="flex min-h-screen flex-col items-center justify-center border border-gray02 bg-white px-6">
        <div className="flex w-full max-w-md flex-col items-center">
          <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-full bg-success">
            <Check className="h-6 w-6 text-white01" />
          </div>

          <h1 className="mb-3 text-center text-2xl font-semibold text-black01">
            Saque realizado com sucesso
          </h1>

          <p className="mb-8 text-center text-base font-medium leading-relaxed text-black01">
            Seu valor será depositado na conta informada em até 24h úteis.
            Obrigado por utilizar a {import.meta.env.VITE_COMPANY}!
          </p>

          <div className="flex w-full flex-col gap-4">
            <button
              onClick={handleOkClick}
              className="w-full rounded-full bg-primary px-6 py-4 text-lg font-semibold uppercase text-white01 transition-colors hover:bg-primary"
            >
              OK
            </button>
          </div>

          {orderCode && (
            <div className="mt-8 text-center">
              <p className="text-sm font-semibold text-black01">
                Pedido:{' '}
                <span className="font-medium text-black04">{orderCode}</span>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CreditWithdrawSuccess
